var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2119",
    "data-name": "Grupo 2119",
    transform: "translate(-1500 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_4_17",
    "data-name": "Componente 4 \\u2013 17",
    transform: "translate(1500 36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2007",
    "data-name": "Grupo 2007",
    transform: "translate(-146 -687)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(146 687)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2107",
    "data-name": "Grupo 2107",
    transform: "translate(6828.676 467.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2108",
    "data-name": "Grupo 2108",
    transform: "translate(-6817.555 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2107-2",
    "data-name": "Grupo 2107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1533",
    "data-name": "Caminho 1533",
    d: "M154.172,65.8l-3.157-.3a12.421,12.421,0,0,0-1.175-2.833l2.02-2.452a.633.633,0,0,0-.038-.851l-3.443-3.443a.642.642,0,0,0-.857-.038l-2.445,2.013a12.456,12.456,0,0,0-2.839-1.175l-.3-3.157a.624.624,0,0,0-.629-.572h-4.865a.635.635,0,0,0-.635.572l-.3,3.157a12.409,12.409,0,0,0-2.833,1.175l-2.452-2.013a.634.634,0,0,0-.851.038l-3.443,3.443a.634.634,0,0,0-.038.851l2.013,2.452a12.4,12.4,0,0,0-1.175,2.833l-3.157.3a.634.634,0,0,0-.572.629V71.3a.634.634,0,0,0,.572.629l3.157.3a12.47,12.47,0,0,0,1.175,2.839l-2.013,2.445a.634.634,0,0,0,.038.851l3.443,3.443a.628.628,0,0,0,.851.045l2.452-2.02a12.4,12.4,0,0,0,2.833,1.175l.3,3.157a.641.641,0,0,0,.635.578H141.3a.63.63,0,0,0,.629-.578l.3-3.157a12.469,12.469,0,0,0,2.839-1.175l2.445,2.02a.636.636,0,0,0,.857-.045l3.443-3.443a.633.633,0,0,0,.038-.851l-2.02-2.445a12.766,12.766,0,0,0,1.182-2.839l3.15-.3a.634.634,0,0,0,.578-.629V66.431A.634.634,0,0,0,154.172,65.8Zm-15.3,11.318a8.251,8.251,0,1,1,8.251-8.251A8.25,8.25,0,0,1,138.871,77.12Z",
    transform: "translate(-122.992 -52.991)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1534",
    "data-name": "Caminho 1534",
    d: "M309.07,213.509a3.076,3.076,0,1,0-3.078-3.078A3.084,3.084,0,0,0,309.07,213.509Z",
    transform: "translate(-293.191 -196.56)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    "data-name": "Caminho 1535",
    d: "M278.416,297.52a4.311,4.311,0,0,1-5.793,0,6.181,6.181,0,0,0-2.706,2.941,6.983,6.983,0,0,0,11.2,0A6.18,6.18,0,0,0,278.416,297.52Z",
    transform: "translate(-259.641 -280.415)",
    fill: "#010066"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.1a10a420155b43c4f541434ee234a5cc.svg";
export { ForwardRef as ReactComponent };